import { css } from '@emotion/react';

import { themeStyled as styled } from '@parapet/common';

export const StyledAuthTypeSelector = styled.div`
  background-color: #0000001c;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 100px;
  margin-bottom: 10px;
  gap: 4px;
`;

export const AuthTypeSelectorButton = styled.button<{
  isSelected: boolean;
}>`
  width: 50%;
  height: 100%;
  border-radius: 100px;
  color: #fff;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  &:hover {
    /* border-color: var(--primary-800); */
    border-color: #fff1;
  }
  &:active {
    transform: scale(1.06);
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      font-weight: 600;
      border-color: var(--primary-500);
      box-shadow: 0 2px 30px -4px #0003;
      &:hover {
        border-color: var(--primary-500);
      }
    `};
`;
